import React from 'react';
import styles from './index.module.scss';

const EulaPage = () => {
  return (
    <main className={styles.container}>
      <section>
        <h1>BF Island End User License Agreement</h1>
        <p>Effective Date: January 30, 2026</p>
        <br />
        <p>
          This End User License Agreement (&quot;EULA&quot;) applies to the BF
          Island mobile application, services, content, features, and properties
          (collectively, the &quot;BF Island&quot;). BF Island is owned and
          controlled by BuzzFeed Media Enterprises, Inc. or the relevant
          BuzzFeed company responsible for providing BF Island
          (&quot;BuzzFeed&quot;, &quot;we&quot;, &quot;us&quot;, or
          &quot;our&quot;). &quot;You&quot;, the end user, of BF Island are
          subject to this EULA, which is incorporated within our User Agreement,
          available here (collectively &quot;Terms&quot;), which we may update
          from time to time. Please read these Terms carefully before using BF
          Island. By accessing BF Island, you agree to and are bound by the
          terms, conditions, policies and notices contained in these Terms.
        </p>
        <p>
          From time to time we may update BF Island and these Terms. Your use of
          BF Island after we post any changes to these Terms constitutes your
          agreement to those changes. BuzzFeed may, in its sole discretion, and
          at any time, discontinue BF Island or any part thereof, with or
          without notice, or may prevent your use of BF Island with or without
          notice to you. You acknowledge that in order to provide improved
          customer experience we may make changes to BF Island. You agree that
          you do not have any rights in BF Island and that BuzzFeed will have no
          liability to you if BF Island is discontinued or your ability to
          access BF Island is terminated.
        </p>
        <p>
          BF Island is intended for users who are at least 13 years old. By
          using BF Island, you represent that you meet this minimum age
          requirement. BuzzFeed does not knowingly collect any personal data
          from individuals under 13.
        </p>
        <h2>License</h2>
        <p>
          BuzzFeed operates BF Island and hereby allows you to add BF Island to
          your device, either by purchasing a license for BF Island or by adding
          it to your device at no charge. Except as otherwise stated, BuzzFeed
          grants you a personal, non-exclusive, non-transferable,
          non-sublicensable limited right and license to use BF Island for your
          personal, non-commercial use (the &quot;License&quot;). Your use of BF
          Island is also subject to our Privacy Policy, which explains what
          information we collect, how we use it, and your choices in connection
          with The App. The rights that BuzzFeed grants you under the License
          are subject to the Terms, and you may only make use of the License if
          you comply with all applicable terms.
        </p>
        <p>
          The License to BF Island becomes effective on the date you accept this
          EULA. BF Island is licensed, not sold, to you under the License. The
          License does not grant you any title or ownership in BF Island.
        </p>
        <p>
          You may not do any of the following with respect to BF Island or any
          of its parts: (a) use it commercially or for a promotional purpose;
          (b) use it on more than one device at a time; (c) copy, reproduce,
          display, perform, or otherwise use it in a way that is not expressly
          authorized by the Terms; (d) sell, rent, lease, license, distribute,
          or otherwise transfer it, including on rooted or
          &quot;jailbroken&quot; devices; (e) reverse engineer, derive source
          code from, modify, adapt, translate, decompile, or disassemble it or
          make derivative works based on it; (f) remove, disable, circumvent, or
          modify any proprietary notice or label or security technology included
          in it; (g) create, develop, distribute, or use any unauthorized
          software programs to gain advantage in any online or other game modes;
          (h) use it to infringe or violate the rights of any third party,
          including but not limited to any intellectual property, publicity, or
          privacy rights; (i) use, export, or re-export it in violation of any
          applicable law or regulation; or (j) behave in a manner which is
          detrimental to the enjoyment of BF Island by other users as intended
          by BuzzFeed, in BuzzFeed&rsquo;s sole judgment, including but not
          limited to the following – cheating, harassment, use of abusive or
          offensive language, game abandonment, game sabotage, spamming, social
          engineering, or scamming.
        </p>
        <h2>Platform Terms</h2>
        <p>
          Your use of BF Island may be subject to the terms of service or end
          user license agreements of the app store from which you downloaded BF
          Island (for example, Apple&rsquo;s App Store or Google Play Terms of
          Service). In the event of conflict between those terms and this EULA,
          the app store terms will govern solely with respect to your use of the
          platform.
        </p>
        <h2>Content</h2>
        <p>
          Content on BF Island that is provided by BuzzFeed or its partners
          (including licensors), including characters, images, recordings, is
          the property of BuzzFeed and its partners, and is protected in the
          U.S. and internationally under trademark, copyright, and other
          intellectual property laws.
        </p>
        <h2>Use of Our Mobile Apps</h2>
        <p>
          The use of BF Island requires a mobile device and wireless mobile data
          service, which must be obtained from your wireless carrier, and may
          require internet access, which must be obtained from your service
          provider; you are responsible for obtaining and paying for such
          additional services and obtaining a suitable device, including without
          limitation all usage charges related thereto. You may be required to
          send and receive, at your cost, electronic communications related to
          BF Island, including without limitation administrative messages,
          service announcements, diagnostic data reports, and application
          updates, from BuzzFeed, your wireless service provider or third party
          service providers. If you do not have an unlimited wireless mobile
          data plan, you may incur additional charges from your wireless service
          provider in connection with your use of BF Island. You are solely
          responsible for obtaining any additional subscription or connectivity
          services or equipment necessary to access BF Island, including but not
          limited to payment of all third party fees associated therewith,
          including fees for information sent to or through BF Island.
        </p>
        <p>
          Neither title nor any intellectual property rights in BF Island are
          transferred to you. Such rights remain with BuzzFeed, who owns full
          and complete title, and BuzzFeed reserves all rights not expressly
          granted to you.
        </p>
        <p>
          BuzzFeed may, at its discretion, automatically download application
          updates to your device. You agree to accept these application updates,
          and to pay for any costs associated with receiving them. You must
          comply with all domestic and international export laws and regulations
          that apply to BF Island and application updates. These laws include
          restrictions on destinations, end users and end use.
        </p>
        <h2>Disclaimers, Representations, and Limitations of Liability</h2>
        <p>
          BuzzFeed makes no representations about the reliability of the
          features of BF Island or any content therein, and disclaims all
          liability in the event of any service failure. You acknowledge that
          any reliance on such material or systems will be at your own risk.
          BuzzFeed makes no representations regarding the amount of time that
          any content on BF Island will be preserved. Neither BuzzFeed nor any
          BuzzFeed Party shall be liable for any damages resulting from the use
          or inability to use BF Island, including but not limited to loss of
          data, system damage, or financial loss. BF Island and all content are
          provided &quot;as-is&quot; and &quot;as available&quot; without
          warranties of any kind, either express or implied, including but not
          limited to implied warranties of merchantability, fitness for a
          particular purpose, title, and non-infringement. BuzzFeed does not
          warrant that BF Island will be uninterrupted or error-free or that any
          defects will be corrected. Some jurisdictions do not allow limitations
          on implied warranties, so some of the above limitations may apply to
          you.
        </p>
        <h2>Indemnity</h2>
        <p>
          You agree to indemnify, pay the defense costs of, and hold harmless
          BuzzFeed, BuzzFeed Parties and their respective employees, officers,
          directors, agents, contractors, and other representatives from all
          claims, demands, actions, losses, liabilities, and expenses (including
          attorneys&rsquo; fees, costs, and expert witnesses&rsquo; fees) that
          arise from or in connection with (a) any claim that, if true, would
          constitute a breach by you of these Terms or negligence by you, (b)
          any act or omission by you in using BF Island, or (c) any claim of
          infringement or violation of any third-party intellectual property
          rights arising from BuzzFeed&rsquo;s use of your feedback, comments,
          or suggestions, which you hereby assign all rights, title, and
          interests to BuzzFeed. You agree to reimburse BuzzFeed Parties on
          demand for any defense costs incurred by a BuzzFeed Party and any
          payments made or loss suffered by a BuzzFeed party, whether in a court
          judgment or settlement.
        </p>
        <p>
          If you are prohibited by law from entering into the indemnification
          obligation above, then you assume, to the extent permitted by law, all
          liability for all claims, demands, actions, losses, liabilities, and
          expenses (including attorneys&rsquo; fees, costs and expert
          witnesses&rsquo; fees) that are the stated subject matter of the
          indemnification obligation above.
        </p>
        <p>
          As used in the above indemnity provisions, the term &quot;BuzzFeed
          Parties&quot; includes the third-party developers, licensors, and
          partners of BuzzFeed used in the ideation, creation, development, and
          publishing of BF Island.
        </p>
        <h2>Miscellaneous</h2>
        <p>
          These Terms constitute a binding agreement between you and BuzzFeed,
          and is accepted by you upon your use of BF Island or your Account.
          These Terms constitute the entire agreement between you and BuzzFeed
          regarding the use of BF Island and your account. By using BF Island
          you represent that you are capable of entering into a binding
          agreement, and that you agree to be bound by these Terms.
        </p>
        <p>
          These Terms are governed by and construed in accordance with the State
          of New York, without regard to conflicts of principles. You agree that
          any dispute or claim arising out of or relating to these Terms or your
          use of BF Island will be brought exclusively in the state or federal
          courts located in New York County, New York, and you consent to the
          personal jurisdiction of such courts.
        </p>
        <h2>Termination</h2>
        <p>
          This EULA will terminate automatically if you breach any of the terms
          hereof. Upon termination, you must cease all use of BF Island and
          remove, disable, or destroy (as appropriate), any and all copies of BF
          Island.
        </p>
      </section>
    </main>
  );
};
export default EulaPage;
